import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { registerService } from '@shared/services/register';

export default function CurrentStatus({ person, onClose }) {
    const { t } = useTranslation();
    const [currentStatus, setCurrentStatus] = useState(null);

    useEffect(() => {
        const recordId = person?.recordId;
        if (!recordId) {
            return;
        }

        registerService
            .getCurrentStatus(recordId)
            .then((data) => {
                setCurrentStatus(data);
            })
            .catch((error) => {
                console.error('Error fetching current status:', error);
                setCurrentStatus(null);
            });
    }, [person]);

    const formatValue = (value) => (value === null || value === undefined ? '' : value);
    const displayName = person
        ? [person.name, person.fathersName, person.surname].filter(Boolean).join(' ') || person.fullName || ''
        : '';

    return (
        <div className="main-person-form-container">
            <h3 className="form-subtitle">
                {t('persons.currentStatus.title', {
                    name: displayName
                })}
            </h3>
            <table className="width-50 margin-auto simple-table">
                <thead>
                    <tr>
                        <th className="background-color-white-blue" colSpan={3}>
                            {t('persons.currentStatus.employmentContract', {
                                contractId: currentStatus ? formatValue(currentStatus.contractId) : '',
                                contractNo: currentStatus ? formatValue(currentStatus.contractNo) : ''
                            })}
                        </th>
                    </tr>
                    <tr>
                        <td>{t('persons.currentStatus.idn')}</td>
                        <td>{currentStatus ? formatValue(currentStatus.idn) : ''}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>{t('persons.currentStatus.employeeNumber')}</td>
                        <td>{currentStatus ? formatValue(currentStatus.contractNo) : ''}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>{t('persons.currentStatus.id')}</td>
                        <td>{currentStatus ? formatValue(currentStatus.contractId) : ''}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>{t('persons.currentStatus.lineManager')}</td>
                        <td>{currentStatus ? formatValue(currentStatus.manager) : ''}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>{t('persons.currentStatus.managerOfTheLineManager')}</td>
                        <td>{currentStatus ? formatValue(currentStatus.managerOfManager) : ''}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>{t('persons.currentStatus.basicMonthlySalary')}</td>
                        <td>{currentStatus ? formatValue(currentStatus.salary) : ''}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>{t('persons.currentStatus.basicMonthlySalaryPlusPercentageForProfessionalExperienceAndQualification')}</td>
                        <td>{currentStatus ? formatValue(currentStatus.salaryWithExperience) : ''}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>{t('persons.currentStatus.professionalExperience')}</td>
                        <td>{currentStatus ? formatValue(currentStatus.experience) : ''}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>{t('persons.currentStatus.percentageForProfessionalExperienceAndQualification')}</td>
                        <td>{currentStatus ? formatValue(currentStatus.percentageExperience) : ''}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>{t('persons.currentStatus.position')}</td>
                        <td>{currentStatus ? formatValue(currentStatus.position) : ''}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>{t('persons.currentStatus.noc')}</td>
                        <td>{currentStatus ? formatValue(currentStatus.nkpd) : ''}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>{t('persons.currentStatus.structuralGroup')}</td>
                        <td>{currentStatus ? formatValue(currentStatus.orgUnit) : ''}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>{t('persons.currentStatus.location')}</td>
                        <td>{currentStatus ? formatValue(currentStatus.location) : ''}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>{t('persons.currentStatus.status')}</td>
                        <td>{currentStatus ? formatValue(currentStatus.statut) : ''}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>{t('persons.currentStatus.dailyStatus')}</td>
                        <td>{currentStatus ? formatValue(currentStatus.dayStatus) : ''}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>{t('persons.currentStatus.jobDescription')}</td>
                        <td>{currentStatus ? formatValue(currentStatus.jobDescription) : ''}</td>
                        <td>
                            <img
                                src="/images/icons/xls.png"
                                alt="XLS"
                                style={{ width: 20, height: 20 }}
                            />
                        </td>
                    </tr>
                </thead>
            </table>
            <div className="form-controls">
                <button className="form-btn btn-red" onClick={onClose}>{t('common.exit')}</button>
            </div>
        </div>
    );
}